import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Collapse, ListItemText, SvgIcon } from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuItemParams } from 'types/routes/route-params';
import { useMemo } from 'react';
import colors from 'assets/theme/base/colors';

interface Props {
    routeParam: MenuItemParams;
    subRouter?: boolean;
}
const MenuItem: React.FC<Props> = (props: Props) => {
    const { routeParam } = props;

    if (routeParam.displayPage === false) {
        return null;
    }

    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [openMenus, setOpenMenus] = React.useState<{
        [key: string]: boolean;
    }>({});

    const handleToggle = (segment: string) => {
        setOpenMenus((prev) => ({
            ...prev,
            [segment]: !prev[segment] ?? true,
        }));
    };

    const handleListItemClicks = (
        _: React.MouseEvent<HTMLLIElement | HTMLDivElement, MouseEvent>,
        routePath: string,
    ) => {
        navigate(routePath);
    };

    const hasChildren = useMemo(() => {
        return (
            routeParam.subRoutes &&
            routeParam.subRoutes.length > 0 &&
            routeParam.subRoutes.some((sub) => sub.displayPage !== false)
        );
    }, [routeParam.subRoutes]);

    const isOpen = openMenus[routeParam.name ?? ''] || false;

    React.useEffect(() => {
        if (hasChildren) {
            const isChildActive = routeParam.subRoutes?.some((sub) =>
                pathname.startsWith(sub.path || ''),
            );
            if (isChildActive) {
                setOpenMenus((prev) => ({
                    ...prev,
                    [routeParam.name ?? '']: true,
                }));
            }
        }
    }, [pathname, routeParam.name, routeParam.subRoutes, hasChildren]);

    return (
        <>
            <ListItemButton
                disableRipple={true}
                selected={pathname === routeParam.path}
                onClick={(event) => {
                    if (hasChildren) {
                        handleToggle(routeParam.name ?? '');
                    } else {
                        handleListItemClicks(event, routeParam.path ?? '');
                    }
                }}
            >
                {routeParam.icon && (
                    <ListItemIcon>
                        <SvgIcon
                            component={routeParam.icon}
                            inheritViewBox
                            sx={{
                                fontSize: pxToRem(20),
                                fill: colors.common.white,
                            }}
                        />
                    </ListItemIcon>
                )}
                <ListItemText
                    sx={{
                        fontSize: pxToRem(10),
                    }}
                >
                    {routeParam.name}
                </ListItemText>
                {hasChildren && (isOpen ? <ExpandLess /> : <ExpandMore />)}
            </ListItemButton>

            {hasChildren && (
                <Collapse in={isOpen} timeout={500} unmountOnExit>
                    <List
                        sx={{ ml: pxToRem(20) }}
                        component="div"
                        disablePadding
                    >
                        {routeParam?.subRoutes
                            ?.filter((route) => route.displayPage !== false)
                            .map((route, index) => (
                                <MenuItem routeParam={route} key={index} />
                            ))}
                    </List>
                </Collapse>
            )}
        </>
    );
};
export default MenuItem;
